import { RolePermissionObjects } from './rolePermissionObjects.constants';

export const RealtimeConfigTab = {
    Parameters: 'parameters',
};

export const realtimeConfigRouteConfig = [
    {
        routerLink: `/dashboard/realtime-config/${RealtimeConfigTab.Parameters}`,
        title: 'Parameters',
        objectId: RolePermissionObjects.Parameter,
    },
];
